import { render, staticRenderFns } from "./SpcmNoteAdd.vue?vue&type=template&id=9e23b7f8&scoped=true"
import script from "./SpcmNoteAdd.vue?vue&type=script&lang=js"
export * from "./SpcmNoteAdd.vue?vue&type=script&lang=js"
import style0 from "./SpcmNoteAdd.vue?vue&type=style&index=0&id=9e23b7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e23b7f8",
  null
  
)

export default component.exports